// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastBackwardFilledSvg from "@ant-design/icons-svg/es/asn/FastBackwardFilled";
import AntdIcon from '../components/AntdIcon';

var FastBackwardFilled = function FastBackwardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardFilledSvg
  }));
};

FastBackwardFilled.displayName = 'FastBackwardFilled';
export default React.forwardRef(FastBackwardFilled);